import { Injectable } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DeviceDetectorResult } from 'device-detector-js';
import { ValuesType } from 'utility-types';
import { FormModel, ModelDetail, ModelID, ServiceStepID, StepID } from '../../form-json.types';
import { FormCoreModule } from '../form-core.module';
import { Model } from '../setup/setup.service';

@Injectable({
  providedIn: FormCoreModule
})
export class DataService {

  device!: DeviceDetectorResult
  queryParams: { [key: string]: string } = {}
  stepsFormGroup: { [key: string]: FormGroup } = {}
  formControls: { [key: string]: FormControl } = {}
  pathValue: { [key: string]: any } = {}
  model: Model = {
    step: {},
    fieldset: {},
    'text-component': {},
    'field-label': {},
    'path-value': {},
    'literal-value': {},
    'eq-condition': {},
    'not-condition': {},
    'pattern-condition': {},
    'array-literal-value': {},
    'in-array-condition': {},
    'and-condition': {},
    'conditional-value': {},
    'truthy-condition': {},
    'or-condition': {},
    'not-blank-condition': {},
    'number-condition': {},
    'gt-condition': {},
    'lt-condition': {},
    'select-component': {},
    'option-component': {},
    'intro-component': {},
    'modal-opener': {},
    'modal-all-requirements-component': {},
    'modal-direct-marketing-policy-component': {},
    'info-component': {},
    'checkbox-group-component': {},
    'checkbox-component': {},
    'checked-condition': {},
    'service-step': {},
    'otp-service': {},
    'checker-service': {},
    'service-handler': {},
    'action-show-modal': {},
    'modal-service-status-component': {},
    'review-component': {},
    'select-text-value': {}
  }
  attributes: ValuesType<Pick<ValuesType<Pick<FormModel, 'data'>>, 'attributes'>> = {
    'button-label-back': '',
    'button-label-error': '',
    'button-label-next': '',
    'header-name': '',
    'button-label-sync': '',
    'form-id': '',
    'button-label-backto': ''
  }
  relationships: { step: (StepID | ServiceStepID)[] } = { step: [] }

  constructor() { }

  getControl(path: string): FormControl {
    return this.formControls[path]
  }

  getModel<T extends ModelDetail>(id: ModelID): T {
    return {...this.model[id.type][id.id]} as T
  }

  getAttributes() {
    return {...this.attributes}
  }

  getSteps() {
    return [...this.relationships.step]
  }
}
